import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'redeem.discount.page.heading': {
    id: 'redeem.discount.page.heading',
    defaultMessage: 'Welcome to edX',
    description: 'Page heading for Redeem Discount page.',
  },
  'redeem.discount.page.subheading': {
    id: 'redeem.discount.page.heading',
    defaultMessage:
      'Please choose from the courses selected by your organization to start learning.',
    description: 'Page sub-heading for Redeem Discount page.',
  },
  'redeem.discount.page.footer.1': {
    id: 'redeem.discount.page.footer.1',
    defaultMessage:
      'Earn a verified certificate in one of our popular courses to advance your career, showcase your accomplishments or enhance your college application.',
    description: 'Footer 1 of Redeem Discount page.',
  },
  'redeem.discount.page.footer.2.heading': {
    id: 'redeem.discount.page.footer.2.heading',
    defaultMessage: 'Why buy a verified certificate?',
    description: 'Footer 2 heading of Redeem Discount page.',
  },
  'redeem.discount.page.footer.2.p1': {
    id: 'redeem.discount.page.footer.2.p1',
    defaultMessage:
      "A verified certificate demonstrates to future employers that you've mastered the course material.",
    description: 'Footer 2 paragraph 1 of Redeem Discount page.',
  },
  'redeem.discount.page.footer.2.p2': {
    id: 'redeem.discount.page.footer.2.p2',
    defaultMessage:
      'The certificate is officially signed and stamped by the institution that offers the course.',
    description: 'Footer 2 paragraph 2 of Redeem Discount page.',
  },
  'redeem.discount.page.footer.2.p3': {
    id: 'redeem.discount.page.footer.2.p3',
    defaultMessage:
      "You're twelve times more likely to complete the course if you're working toward a verified certificate.",
    description: 'Footer 2 paragraph 3 of Redeem Discount page.',
  },
  'redeem.discount.product.off': {
    id: 'redeem.discount.product.off',
    defaultMessage: 'OFF',
    description: 'Off on product.',
  },
  'redeem.discount.product.course.start': {
    id: 'redeem.discount.course.start',
    defaultMessage: 'Course Start: ',
    description: 'Course start date.',
  },
  'redeem.discount.product.discount.end': {
    id: 'redeem.discount.course.end',
    defaultMessage: 'Discount valid until ',
    description: 'Discount expiry date.',
  },
  'redeem.discount.product.discount.now': {
    id: 'redeem.discount.course.now',
    defaultMessage: 'Now ',
    description: 'Current price text.',
  },
  'redeem.discount.product.discount.checkout': {
    id: 'redeem.discount.course.checkout',
    defaultMessage: 'Checkout',
    description: 'checkout button.',
  },
  'redeem.discount.product.discount.enrollment': {
    id: 'redeem.discount.course.enrollment',
    defaultMessage: 'Enroll Now',
    description: 'Enroll now button.',
  },
  'redeem.discount.page.loader': {
    id: 'redeem.discount.page.loader',
    defaultMessage: 'Loading products...',
    description: 'Message when products are being loaded',
  },
});
